import { useNavigate } from "react-router";

import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPagePolicy } from "hooks/useAnalytics/pages/policy";
import { AccessResult } from "utils/access";

import { showDeleteConfirmation } from "../Policies/DeleteConfirmation";

type PolicyDetailsManageDropdownProps = {
  handlePolicyEditDetailsClick: () => void;
  id: string;
  name: string;
  size?: "small" | "medium";
  canManagePolicy: AccessResult;
  hasAttachedEntities: boolean;
};

const PolicyDetailsManageDropdown = ({
  handlePolicyEditDetailsClick,
  id,
  name,
  size = "small",
  canManagePolicy,
  hasAttachedEntities,
}: PolicyDetailsManageDropdownProps) => {
  const navigate = useNavigate();

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPagePolicy.PolicyDetails,
  });

  const copyFieldCallback = () => trackSegmentAnalyticsEvent("Copy ID");

  const handleDelete = () => {
    showDeleteConfirmation({
      id,
      hasAttachedEntities,
      name,
    }).then((finished) => {
      if (finished) {
        navigate(`/policies`);
        trackSegmentAnalyticsEvent("Confirm Delete");
      }
    });
  };
  const showActionButtons = canManagePolicy.result || !!canManagePolicy.message;

  return (
    <DropdownMenuEllipsis tooltip="Policy actions" dotsSize={size}>
      {showActionButtons && (
        <DropdownMenuItem
          tooltip={canManagePolicy.message}
          isDisabled={!canManagePolicy.result}
          onAction={handlePolicyEditDetailsClick}
        >
          Edit details
        </DropdownMenuItem>
      )}
      <CopyFieldDropdownMenuItem title="Copy ID" value={id} onCopy={copyFieldCallback} />
      {showActionButtons && (
        <DropdownMenuItem
          tooltip={canManagePolicy.message}
          isDisabled={!canManagePolicy.result}
          onAction={handleDelete}
          danger
        >
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default PolicyDetailsManageDropdown;
